import {createApp, defineAsyncComponent, h, reactive} from 'vue';
import AppWrapper from '../layout/AppWrapper.vue';
import router from './router';
import PrimeVue from 'primevue/config';
import AutoComplete from 'primevue/autocomplete';
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import Avatar from 'primevue/avatar';
import AvatarGroup from 'primevue/avatargroup';
import Badge from 'primevue/badge';
import BadgeDirective from "primevue/badgedirective";
import Button from 'primevue/button';
import Breadcrumb from 'primevue/breadcrumb';
import Calendar from 'primevue/calendar';
import Card from 'primevue/card';
import CascadeSelect from 'primevue/cascadeselect';
import Carousel from 'primevue/carousel';
import Chart from 'primevue/chart';
import Checkbox from 'primevue/checkbox';
import Chip from 'primevue/chip';
import Chips from 'primevue/chips';
import ColorPicker from 'primevue/colorpicker';
import Column from 'primevue/column';
import ConfirmDialog from 'primevue/confirmdialog';
import ConfirmPopup from 'primevue/confirmpopup';
import ConfirmationService from 'primevue/confirmationservice';
import ContextMenu from 'primevue/contextmenu';
import DataTable from 'primevue/datatable';
import DataView from 'primevue/dataview';
import DataViewLayoutOptions from 'primevue/dataviewlayoutoptions';
import Dialog from 'primevue/dialog';
import Divider from 'primevue/divider';
import Dropdown from 'primevue/dropdown';
import Fieldset from 'primevue/fieldset';
import FileUpload from 'primevue/fileupload';
import Galleria from 'primevue/galleria';
import Image from 'primevue/image';
import InlineMessage from 'primevue/inlinemessage';
import Inplace from 'primevue/inplace';
import InputSwitch from 'primevue/inputswitch';
import InputText from 'primevue/inputtext';
import InputMask from 'primevue/inputmask';
import InputNumber from 'primevue/inputnumber';
import Knob from 'primevue/knob';
import Listbox from 'primevue/listbox';
import MegaMenu from 'primevue/megamenu';
import Menu from 'primevue/menu';
import Menubar from 'primevue/menubar';
import Message from 'primevue/message';
import MultiSelect from 'primevue/multiselect';
import OrderList from 'primevue/orderlist';
import OrganizationChart from 'primevue/organizationchart';
import OverlayPanel from 'primevue/overlaypanel';
import Paginator from 'primevue/paginator';
import Panel from 'primevue/panel';
import PanelMenu from 'primevue/panelmenu';
import Password from 'primevue/password';
import PickList from 'primevue/picklist';
import ProgressBar from 'primevue/progressbar';
import Rating from 'primevue/rating';
import RadioButton from 'primevue/radiobutton';
import Ripple from 'primevue/ripple';
import SelectButton from 'primevue/selectbutton';
import ScrollPanel from 'primevue/scrollpanel';
import ScrollTop from 'primevue/scrolltop';
import Skeleton from 'primevue/skeleton';
import Slider from 'primevue/slider';
import Sidebar from 'primevue/sidebar';
import SplitButton from 'primevue/splitbutton';
import Splitter from 'primevue/splitter';
import SplitterPanel from 'primevue/splitterpanel';
import StyleClass from 'primevue/styleclass';
import Steps from 'primevue/steps';
import SpeedDial from 'primevue/speeddial';
import TabMenu from 'primevue/tabmenu';
import TieredMenu from 'primevue/tieredmenu';
import Textarea from 'primevue/textarea';
import Toast from 'primevue/toast';
import ToastService from 'primevue/toastservice';
import DebouncedToastService from './debounced-toast-service';
import CustomDialogService from './custom-dialog-service';
import Toolbar from 'primevue/toolbar';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import Tag from 'primevue/tag';
import Timeline from 'primevue/timeline';
import ToggleButton from 'primevue/togglebutton';
import Tooltip from 'primevue/tooltip';
import Tree from 'primevue/tree';
import TreeSelect from 'primevue/treeselect';
import TreeTable from 'primevue/treetable';
import TriStateCheckbox from 'primevue/tristatecheckbox';
import ProgressSpinner from 'primevue/progressspinner';
import FocusTrap from 'primevue/focustrap';
import VirtualScroller from 'primevue/virtualscroller';

import EventBus from '@/js/event-bus';
import {} from '@/js/extensions/array';
import {} from '@/js/extensions/string';
import {} from '@/js/extensions/date';

import momentLocale from "moment/min/moment-with-locales.min.js";
import moment from "moment";
import VueTelInput from 'vue-tel-input';
import 'vue-tel-input/vue-tel-input.css';
import readXlsxFile from 'read-excel-file';

import 'primevue/resources/primevue.min.css';
import 'primeicons/primeicons.css';
import '../assets/pages/primeflex.min.css';
import 'material-icons/iconfont/material-icons.css';
//import 'primevue/resources/themes/lara-light-blue/theme.css';
//import loading-overlay css
import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';

import VueTreeSelect from "@bosquig/vue3-treeselect";
import "@bosquig/vue3-treeselect/dist/vue3-treeselect.css";

import store from '@/js/store.js';
import en from '@/lang/en.json'
import ro from '@/lang/ro.json'
import {createI18n} from 'vue-i18n'

import VueSocketIO from 'vue-3-socket.io'
import socketio from 'socket.io-client'
import {config} from "@/config/config";
import DynamicDialog from "primevue/dynamicdialog";

//import './workers/registerUploadWorker'
import mitt from 'mitt';
import 'shepherd.js/dist/css/shepherd.css';

import {VueReCaptcha} from 'vue-recaptcha-v3'

import DOMPurify from 'dompurify';
import PrimeContextMenuFit from '@/plugins/primeContextMenuFit.js';

momentLocale.locale(config.MOMENT_LOCALE || 'ro');
moment.defineLocale(config.MOMENT_LOCALE || 'ro', momentLocale.localeData()._config);
moment.tz?.setDefault(config.MOMENT_TIMEZONE || 'Europe/Bucharest');

const purify = DOMPurify(window);

const messages = Object.assign({en, ro})
const i18n = createI18n({
  locale: 'ro',
  fallbackLocale: 'en',
  globalInjection: true,
  messages,
  silentTranslationWarn: true,
  silentFallbackWarn: true
})

const app = createApp({
  render() {
    return h(AppWrapper);
  },
  data() {
    return {
      windowData: reactive({
        width: window.innerWidth,
        height: window.innerHeight,
        belowSm: window.innerWidth <= 576,
        aboveSm: window.innerWidth > 576,
        belowMd: window.innerWidth <= 768,
        aboveMd: window.innerWidth > 768,
        belowLg: window.innerWidth <= 992,
        aboveLg: window.innerWidth > 992,
        belowXl: window.innerWidth <= 1200,
        aboveXl: window.innerWidth > 1200,
      }),
    };
  },
  created() {
    window.addEventListener('resize', () => {
      this.windowData.width = window.innerWidth;
      this.windowData.height = window.innerHeight;
      this.windowData.belowSm = window.innerWidth <= 576;
      this.windowData.aboveSm = window.innerWidth > 576;
      this.windowData.belowMd = window.innerWidth <= 768;
      this.windowData.aboveMd = window.innerWidth > 768;
      this.windowData.belowLg = window.innerWidth <= 992;
      this.windowData.aboveLg = window.innerWidth > 992;
      this.windowData.belowXl = window.innerWidth <= 1200;
      this.windowData.aboveXl = window.innerWidth > 1200;
    });
  },
  provide() {
    return {
      windowData: this.windowData
    };
  }
});

window['mainApp'] = app;

const emitter = mitt();
app.config.globalProperties.$emitter = emitter;

const loadKonva = async () => {
  const [{default: VueKonva}, Konva] = await Promise.all([
    import('vue-konva'),
    import('konva')
  ]);

  // Konva.default.pixelRatio = 1;

  app.use(VueKonva, {prefix: 'konva'});
};
app.config.globalProperties.$loadKonva = loadKonva;

const socketInstance = socketio(config.SOCKET_URL/*'localhost:3030'*/, {transports: ['websocket']})
app.use(new VueSocketIO({
  debug: true,
  connection: socketInstance,
  vuex: {
    store,
    actionPrefix: 'SOCKET_',
    mutationPrefix: 'SOCKET_'
  }
}))

const chatSocket = socketio(`${config.SOCKET_URL}/chat`, { transports: ['websocket'] })
app.config.globalProperties.$chatSocket = chatSocket;

app.use(i18n);
app.use(PrimeVue, {ripple: true});
app.use(ConfirmationService);
app.use(ToastService);
app.use(DebouncedToastService);
app.use(CustomDialogService);
app.use(store);
app.use(router);
app.use(VueTelInput);
app.use(VueReCaptcha, {siteKey: config.CAPTCHA_KEY})
app.use(PrimeContextMenuFit);


app.config.globalProperties.$appState = reactive({colorScheme: 'dark'});
app.config.globalProperties.$moment = moment;
app.config.globalProperties.$purify = purify;
app.config.globalProperties.$eventBus = EventBus;
app.config.globalProperties.$readXlsxFile = readXlsxFile;
app.config.globalProperties.$config = config;
app.config.errorHandler = (err, instance) => {
  console.log(err);

  if (location.hostname === "localhost" || location.hostname === "127.0.0.1" || location.hostname === ""){
    return;
  }

  const navigatorData = {};

  for (let key in navigator) {
    try {
      const value = navigator[key];
      // Only include properties that are not functions
      if (typeof value !== 'function') {
        navigatorData[key] = value;
      }
    } catch (e) {
      navigatorData[key] = `Error accessing property: ${e.message}`;
    }
  }

 const document = {
    documentCategoryId: 276,
    documentTypeId: 1008,
    title: err.toString(),
    description: err.stack,
    fields: navigatorData,
    status: {
      title: 'In lucru',
      statusId: 24,
    },
  };

  // Commented out due to type mismatch. TIMISOARA 276/1008 29.08.2025
  // instance.$store.dispatch('addDocument', { data: document }).then((rsp) => {
  //   // instance.$toast.add({
  //   //   severity: 'error',
  //   //   summary: 'Error',
  //   //   detail: instance.$t(`A apărut o eroare. Vă rugăm să raportați codul de eroare: ${rsp.documentId}`),
  //   //   life: 5000,
  //   // });
  // });
};

app.directive('tooltip', Tooltip);
app.directive('badge', BadgeDirective);
app.directive('ripple', Ripple);
app.directive('styleclass', StyleClass);
app.directive('focustrap', FocusTrap);

app.component('VueTreeSelect', VueTreeSelect);
app.component('Accordion', Accordion);
app.component('AccordionTab', AccordionTab);
app.component('AutoComplete', AutoComplete);
app.component('Avatar', Avatar);
app.component('AvatarGroup', AvatarGroup);
app.component('Badge', Badge);
app.component('Breadcrumb', Breadcrumb);
app.component('Button', Button);
app.component('Calendar', Calendar);
app.component('Card', Card);
app.component('Carousel', Carousel);
app.component('CascadeSelect', CascadeSelect);
app.component('Chart', Chart);
app.component('Checkbox', Checkbox);
app.component('Chip', Chip);
app.component('Chips', Chips);
app.component('ColorPicker', ColorPicker);
app.component('Column', Column);
app.component('ConfirmDialog', ConfirmDialog);
app.component('ConfirmPopup', ConfirmPopup);
app.component('ContextMenu', ContextMenu);
app.component('DataTable', DataTable);
app.component('DataView', DataView);
app.component('DataViewLayoutOptions', DataViewLayoutOptions);
app.component('Dialog', Dialog);
app.component('Divider', Divider);
app.component('Dropdown', Dropdown);
app.component('Fieldset', Fieldset);
app.component('FileUpload', FileUpload);
app.component('Galleria', Galleria);
app.component('Image', Image);
app.component('InlineMessage', InlineMessage);
app.component('Inplace', Inplace);
app.component('InputMask', InputMask);
app.component('InputNumber', InputNumber);
app.component('InputSwitch', InputSwitch);
app.component('InputText', InputText);
app.component('Knob', Knob);
app.component('Listbox', Listbox);
app.component('MegaMenu', MegaMenu);
app.component('Menu', Menu);
app.component('Menubar', Menubar);
app.component('Message', Message);
app.component('MultiSelect', MultiSelect);
app.component('OrderList', OrderList);
app.component('OrganizationChart', OrganizationChart);
app.component('OverlayPanel', OverlayPanel);
app.component('Paginator', Paginator);
app.component('Panel', Panel);
app.component('PanelMenu', PanelMenu);
app.component('Password', Password);
app.component('PickList', PickList);
app.component('ProgressBar', ProgressBar);
app.component('RadioButton', RadioButton);
app.component('Rating', Rating);
app.component('SelectButton', SelectButton);
app.component('ScrollPanel', ScrollPanel);
app.component('ScrollTop', ScrollTop);
app.component('Slider', Slider);
app.component('Sidebar', Sidebar);
app.component('Skeleton', Skeleton);
app.component('SplitButton', SplitButton);
app.component('Splitter', Splitter);
app.component('SplitterPanel', SplitterPanel);
app.component('Steps', Steps);
app.component('SpeedDial', SpeedDial)
app.component('TabMenu', TabMenu);
app.component('TabView', TabView);
app.component('TabPanel', TabPanel);
app.component('Tag', Tag);
app.component('Textarea', Textarea);
app.component('TieredMenu', TieredMenu);
app.component('Timeline', Timeline);
app.component('Toast', Toast);
app.component('DynamicDialog', DynamicDialog);
app.component('Toolbar', Toolbar);
app.component('ToggleButton', ToggleButton);
app.component('Tree', Tree);
app.component('TreeSelect', TreeSelect);
app.component('TreeTable', TreeTable);
app.component('TriStateCheckbox', TriStateCheckbox);
app.component('ProgressSpinner', ProgressSpinner);
app.component('VirtualScroller', VirtualScroller);

// custom global components
app.component('DocumentElements', defineAsyncComponent(() => import('@/components/document/DocumentElements.vue')));
app.component('RenderElement', defineAsyncComponent(() => import('@/components/document/RenderElement.vue')));
app.component('DataSourceProperties', defineAsyncComponent(() => import('@/components/document/properties/common/DataSourceProperties.vue')));
app.component('SyncModal', defineAsyncComponent(() => import('@/components/common/SyncModal.vue')));
app.component('CardViewModal', defineAsyncComponent(() => import('@/components/common/CardViewModal.vue')));
app.component('CardView', defineAsyncComponent(() => import('@/components/common/CardView.vue')));
app.component('LayoutDataView', defineAsyncComponent(() => import('@/components/common/LayoutDataView.vue')));
app.component('FilteredListView', defineAsyncComponent(() => import('@/components/common/FilteredListView.vue')));
app.component('EventsOptions', defineAsyncComponent(() => import('@/components/document/properties/common/EventsOptions.vue')));
app.component('EventSettings', defineAsyncComponent(() => import('@/components/document/properties/common/EventSettings.vue')));
app.component('LayerRulesLegend', defineAsyncComponent(() => import('@/components/content/LayerRulesLegend.vue')));
app.component('TextInput', defineAsyncComponent(() => import('@/components/inputs/TextInput.vue')));
app.component('TextareaInput', defineAsyncComponent(() => import('@/components/inputs/TextareaInput.vue')));
app.component('EditorInput', defineAsyncComponent(() => import('@/components/inputs/EditorInput.vue')));

/*
* Mobile related code using Capacitor JS
 */
import {Device} from '@capacitor/device';
import {App as CapacitorApp} from '@capacitor/app';
import MapboxSelector from './mapboxSelector';
import {setMapbox} from './mapboxService';
import { mapboxglref } from "@/js/mapboxService";
import {useCertificatePicker} from '../services/certficatePickerService';

(async (app) => {
  const mapboxgl = await MapboxSelector.load();
  mapboxgl.accessToken = config.MAPBOX_TOKEN;
  setMapbox(mapboxgl);
  const initializedMapboxgl = mapboxglref();


  app.config.globalProperties.$deviceInfo = await Device.getInfo();

  app.config.globalProperties.$certificatePicker = useCertificatePicker(app);


  if (app.config.globalProperties.$deviceInfo.platform !== 'web') {
    await CapacitorApp.addListener('backButton', ({canGoBack}) => {
      if (!canGoBack) {
        CapacitorApp.exitApp();
      } else {
        window.history.back();
      }
    });
  }

  app.mixin({
    mounted() {
      //console.log(`Mounted: ${this.$options.name || 'Unnamed Component'}`, location.pathname);
      const preloader = document.querySelector('#preloader');

      if (preloader) {
        // remove preloader when AppWrapper is mounted
        if (this.$options.name === 'AppWrapper') {
          preloader.remove();
        }
      }
    }
  });

  router.isReady().then(() => app.mount('#app'));
})(app)


// update page title to app name
document.getElementsByTagName('title')[0].innerText = config.APP_NAME + ' ' + config.APP_VERSION;
